import { render } from "./InspirationSection.vue?vue&type=template&id=79c833da&scoped=true"
import script from "./InspirationSection.vue?vue&type=script&lang=js"
export * from "./InspirationSection.vue?vue&type=script&lang=js"

import "./InspirationSection.vue?vue&type=style&index=0&id=79c833da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c833da"]])

export default __exports__